export default
`Beste {klant}

Er is een account voor jullie aangemaakt in onze verzendsoftware. Hiermee kunnen jullie pakketten aanmelden en volgen. Om gebruik te maken van jullie account dien je eerst een wachtwoord aan te maken, klik hiervoor op onderstaande knop.

Met vriendelijke groet,
{bedrijfsnaam}`
